import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSphereXgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.38739 16.445C6.37615 16.904 6.44734 17.3855 6.58036 17.7621C6.86887 18.5771 7.55644 19.1429 8.09975 18.0862C8.57 16.9453 8.32083 15.4109 7.79438 14.8488C7.15926 14.1744 6.42111 15.0081 6.38739 16.445Z",
			fill: "url(#paint0_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.89064 14.5203C8.01803 15.5526 8.85548 16.2702 9.75101 15.1461C10.4648 14.0782 10.3093 12.8923 9.97021 12.3921C9.37444 11.5097 8.20913 12.2197 7.92811 13.6361C7.8719 13.9227 7.85691 14.2524 7.89064 14.5203Z",
			fill: "url(#paint1_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.11477 19.8039C8.46886 20.943 9.60045 21.846 10.2187 20.7294C10.6515 19.7009 10.1868 18.3426 9.48429 17.8143C8.62811 17.1717 7.8375 17.9529 8.00049 19.2794C8.01922 19.4349 8.06606 19.6503 8.11477 19.8039Z",
			fill: "url(#paint2_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.62013 15.1167C7.06602 14.1799 7.20653 12.5744 6.88429 12.1004C6.58266 11.6564 6.03373 12.4114 5.79767 13.5973C5.66278 14.2792 5.6609 14.9668 5.79579 15.3527C5.8239 15.4352 6.09555 16.1415 6.62013 15.1167Z",
			fill: "url(#paint3_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.21734 20.7467C7.326 19.6301 6.80892 18.0545 6.34242 17.693C5.89278 17.3445 5.65859 18.1332 5.8703 19.2873C5.99207 19.9449 6.24125 20.6006 6.50916 20.9603C6.60096 21.084 7.06746 21.6535 7.21734 20.7467Z",
			fill: "url(#paint4_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.49971 16.4769C9.49409 16.5836 9.49784 16.726 9.50721 16.8328C9.63835 18.2192 10.9329 19.0735 11.8378 17.9475C12.3943 17.1775 12.3231 15.8979 11.6823 15.2104C10.8168 14.2793 9.57278 15.0024 9.49971 16.4769Z",
			fill: "url(#paint5_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.34725 12.3121C9.06854 11.3417 9.18469 10.2195 8.98985 9.78106C8.70321 9.13471 7.8133 9.77544 7.3468 10.9632C7.107 11.5759 7.11262 12.0161 7.1276 12.1791C7.17819 12.758 7.59972 13.2002 8.34725 12.3121Z",
			fill: "url(#paint6_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.35126 23.2081C9.47304 22.3425 8.74612 20.8531 8.0342 20.5065C7.40471 20.1993 7.13867 20.9131 7.49838 21.9453C7.60704 22.2545 7.76254 22.5617 7.94802 22.8353C8.43138 23.5416 9.18827 24.0643 9.35126 23.2081Z",
			fill: "url(#paint7_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.21309 16.4336C5.22246 17.3647 5.34424 18.2359 5.49037 18.4157C5.63276 18.5899 5.70395 18.0935 5.7283 17.9305C5.85945 16.9019 5.73205 15.1015 5.51098 14.8242C5.34237 14.6144 5.20373 15.3676 5.21309 16.4336Z",
			fill: "url(#paint8_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2487 10.999C10.1831 11.1995 10.1456 11.3962 10.1419 11.5892C10.1157 12.6364 11.0487 13.1629 12.0004 12.2486C12.5774 11.6472 12.776 10.673 12.4407 10.0791C11.9517 9.21545 10.6627 9.75689 10.2487 10.999Z",
			fill: "url(#paint9_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.6827 23.1068C13.0724 22.2488 12.5384 21.1322 11.8021 20.705C10.9085 20.1879 10.1478 20.853 10.4008 21.934C10.6668 23.0768 12.0438 24.1503 12.6827 23.1068Z",
			fill: "url(#paint10_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.04318 20.5444C5.86707 20.4619 6.00945 21.0933 6.35605 21.9251C6.71951 22.7981 7.12043 23.4539 7.26844 23.5213C7.39396 23.5775 7.31153 23.2572 7.27781 23.1204C6.99491 22.1293 6.29048 20.6605 6.04318 20.5444Z",
			fill: "url(#paint11_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.16858 12.2168C6.66693 11.2258 7.08097 9.83564 6.98729 9.64267C6.90673 9.47781 6.53953 10.0886 6.2023 10.9504C5.89692 11.7297 5.70957 12.4885 5.78264 12.644C5.85758 12.7995 6.09176 12.3611 6.16858 12.2168Z",
			fill: "url(#paint12_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.0595 14.9493C14.7733 14.0818 14.5391 13.1919 14.2862 12.8022C13.578 11.71 12.0549 12.2402 11.815 13.664C11.8001 13.7558 11.7888 13.8776 11.7888 13.9713C11.7869 15.234 13.0253 15.9909 14.0595 14.9493Z",
			fill: "url(#paint13_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.63237 8.56337C9.46376 8.865 9.36446 9.18537 9.35697 9.44016C9.33823 10.0303 9.82534 10.3975 10.6572 9.65561C11.2454 9.09544 11.6052 8.16807 11.4272 7.66972C11.1855 6.99714 10.1513 7.6285 9.63237 8.56337Z",
			fill: "url(#paint14_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3237 20.5403C14.9626 19.6223 14.4699 18.6256 14.009 18.2134C13.0872 17.3872 11.8376 18.0205 11.8882 19.2907C11.9369 20.4991 13.3439 21.6588 14.3237 20.5403Z",
			fill: "url(#paint15_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.0018 24.5852C10.4851 25.3609 11.6354 26.2058 11.8284 25.3534C11.9108 24.5159 11.1052 23.4405 10.412 23.1801C9.73759 22.9272 9.46219 23.5117 9.86499 24.3379C9.90246 24.4148 9.95679 24.5122 10.0018 24.5852Z",
			fill: "url(#paint16_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.17551 25.6511C9.52023 25.8347 9.42281 25.4693 9.39096 25.3494C9.16989 24.6132 8.19193 23.2287 7.73105 23.1237C7.41817 23.0526 7.53246 23.6165 7.9746 24.3303C8.38489 24.9916 8.9001 25.5031 9.17551 25.6511Z",
			fill: "url(#paint17_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.23107 9.89844C7.24419 10.0071 7.33037 10.3087 7.92989 9.65114C8.63432 8.8137 9.05772 7.75518 8.98841 7.47791C8.90972 7.16129 8.25587 7.72146 7.74066 8.54954C7.35472 9.17341 7.20672 9.6755 7.23107 9.89844Z",
			fill: "url(#paint18_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5756 17.6978C17.2613 16.8735 16.9391 15.9649 16.555 15.5546C15.6988 14.6384 14.29 15.2024 14.2 16.4988C14.1963 16.5419 14.1963 16.6 14.1963 16.6449C14.2206 17.8796 15.5771 18.6814 16.5756 17.6978Z",
			fill: "url(#paint19_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.8826 27.2288C11.596 26.5075 10.5281 25.4771 10.0691 25.479C9.76747 25.4809 9.88363 25.9212 10.3202 26.4439C10.6405 26.826 11.1014 27.2082 11.4667 27.3956C11.8339 27.5848 11.9744 27.5286 11.8826 27.2288Z",
			fill: "url(#paint20_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.2905 7.29246C10.9331 6.75477 11.4464 5.90608 11.4015 5.61382C11.3471 5.26348 10.5396 5.78805 9.99821 6.42129C9.6947 6.77725 9.49799 7.13321 9.46989 7.37114C9.44178 7.62594 9.63663 7.81516 10.2905 7.29246Z",
			fill: "url(#paint21_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.997 8.57795C12.9333 8.73158 12.8959 8.88333 12.8865 9.02946C12.8322 9.92124 13.7876 10.2247 14.537 9.55591C15.1965 8.91518 15.1366 8.25384 14.996 7.96345C14.5932 7.126 13.3923 7.62997 12.997 8.57795Z",
			fill: "url(#paint22_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.2232 25.2235C15.5492 24.5997 15.1407 23.7978 14.5543 23.4419C13.7244 22.9379 12.9619 23.4419 13.2148 24.3261C13.4602 25.1898 14.6761 26.0067 15.2232 25.2235Z",
			fill: "url(#paint23_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.243 7.24392C13.8781 6.70249 14.0149 6.10485 13.9512 5.83319C13.8106 5.23555 12.8402 5.68144 12.3362 6.41397C12.1638 6.66314 12.102 6.85986 12.0795 6.98164C11.9765 7.55679 12.5029 7.7966 13.243 7.24392Z",
			fill: "url(#paint24_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3707 27.1876C14.4381 26.5918 13.7187 25.7113 13.0424 25.5614C12.4916 25.4396 12.2949 25.8668 12.6358 26.44C13.0649 27.1576 14.1927 27.8395 14.3707 27.1876Z",
			fill: "url(#paint25_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.9072 22.9162C17.428 22.2455 17.0889 21.4999 16.7329 21.1627C15.9142 20.3833 14.6702 20.8648 14.747 21.9289C14.822 22.9799 16.1053 23.7368 16.9072 22.9162Z",
			fill: "url(#paint26_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.8901 10.4231C16.345 9.46954 14.878 9.84985 14.6157 11.0114C14.5989 11.0845 14.5858 11.1838 14.582 11.2587C14.5389 12.2704 15.663 12.8718 16.6073 12.0437C17.3379 11.2662 16.937 10.5056 16.8901 10.4231Z",
			fill: "url(#paint27_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.59472 7.23498C9.03499 6.78535 9.99047 5.67624 9.97735 5.55072C9.90803 5.51138 9.41531 5.96663 9.02187 6.39941C8.60409 6.85841 8.17318 7.4242 8.20503 7.53474C8.25374 7.55909 8.39613 7.4317 8.59472 7.23498Z",
			fill: "url(#paint28_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.64308 25.5352C8.6206 25.6232 8.98406 26.0616 9.33815 26.4307C9.87396 26.989 10.4416 27.4555 10.5147 27.4293C10.5184 27.3993 10.4791 27.3412 10.3442 27.182C10.037 26.8298 8.78359 25.4827 8.64308 25.5352Z",
			fill: "url(#paint29_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1038 19.308C17.0458 20.4508 18.4209 21.0785 19.2377 20.2822C19.8316 19.6321 19.5581 18.9446 19.3033 18.6411C18.5595 17.7568 17.1619 18.1821 17.1038 19.308Z",
			fill: "url(#paint30_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.178 14.673C19.7888 14.0004 19.5265 13.3072 19.2773 13.0018C18.5654 12.1419 17.1921 12.5484 17.0497 13.6613C17.046 13.6969 17.0422 13.7437 17.0404 13.7812C17.0104 14.7404 18.1757 15.5779 19.178 14.673Z",
			fill: "url(#paint31_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.4398 28.7444C14.1813 28.2385 13.2614 27.536 12.8511 27.5322C12.5757 27.5304 12.6712 27.8414 13.0572 28.2011C13.3157 28.4427 13.6754 28.6807 13.9958 28.8212C14.2581 28.9373 14.5485 29.0198 14.4398 28.7444Z",
			fill: "url(#paint32_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.8251 28.7409C12.3174 28.2819 11.2813 27.525 11.0603 27.5269C10.9254 27.5287 11.1521 27.8154 11.6579 28.1957C12.2181 28.6172 12.9038 28.9769 12.9656 28.9132C12.9637 28.8795 12.9356 28.8458 12.8251 28.7409Z",
			fill: "url(#paint33_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9261 5.22974C13.595 4.76137 13.8985 4.24429 13.9041 4.0813C13.9153 3.78154 13.1715 4.13937 12.6582 4.60775C12.4109 4.83256 12.2423 5.05925 12.1936 5.22787C12.1243 5.46767 12.306 5.62692 12.9261 5.22974Z",
			fill: "url(#paint34_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9798 5.22651C11.5906 4.79374 12.3287 4.11179 12.3493 3.99376C12.3718 3.86636 11.7704 4.20172 11.2571 4.60077C10.7906 4.96422 10.5152 5.27897 10.4833 5.40074C10.4646 5.47568 10.5039 5.55062 10.9798 5.22651Z",
			fill: "url(#paint35_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8132 6.44064C15.7851 6.51183 15.757 6.60925 15.7495 6.67857C15.6633 7.3474 16.4445 7.61156 17.0347 7.11509C17.5518 6.63548 17.3888 6.16711 17.3494 6.07718C17.0853 5.45706 16.1223 5.68562 15.8132 6.44064Z",
			fill: "url(#paint36_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.119 25.8223C16.5514 25.5057 15.8938 25.7811 16.0755 26.4368C16.2404 27.0269 17.1115 27.5777 17.5537 27.0475C17.8309 26.6129 17.5518 26.064 17.119 25.8223Z",
			fill: "url(#paint37_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.6846 24.3303C17.709 25.0816 18.6439 25.608 19.2921 25.0254C19.6387 24.6806 19.6143 24.1186 19.2415 23.7739C18.6813 23.2568 17.6565 23.5022 17.6846 24.3303Z",
			fill: "url(#paint38_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.5256 8.58883C17.52 8.61506 17.5143 8.65065 17.5125 8.67688C17.4319 9.45438 18.3612 9.96771 19.1143 9.33073C19.4497 9.01598 19.5115 8.52326 19.2604 8.16168C18.7939 7.48722 17.6923 7.75888 17.5256 8.58883Z",
			fill: "url(#paint39_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6862 28.6808C16.763 28.3417 16.2778 27.7328 15.7419 27.6335C15.3785 27.5661 15.1687 27.8021 15.4441 28.2087C15.7476 28.6583 16.555 29.0854 16.6862 28.6808Z",
			fill: "url(#paint40_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7664 5.14802C16.3191 4.71899 16.2647 4.29184 16.2629 4.27498C16.1973 3.82534 15.4554 4.10074 15.0694 4.6122C14.9458 4.77707 14.9027 4.90634 14.8877 4.9869C14.8146 5.39719 15.2999 5.48525 15.7664 5.14802Z",
			fill: "url(#paint41_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6757 3.57255C14.0673 3.37208 14.8579 2.86624 14.8541 2.78568C14.7979 2.74447 14.3033 2.94493 13.8911 3.17724C13.4827 3.40768 13.2467 3.60814 13.2242 3.6887C13.2129 3.73554 13.2542 3.78425 13.6757 3.57255Z",
			fill: "url(#paint42_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.4122 29.8925C15.0825 29.6827 14.0258 29.1038 13.8647 29.1506C13.786 29.1731 13.9827 29.3511 14.393 29.5665C14.8445 29.8045 15.4141 30.0124 15.5246 29.9993C15.5265 29.9956 15.5284 29.99 15.5302 29.9862C15.5152 29.9618 15.4928 29.945 15.4122 29.8925Z",
			fill: "url(#paint43_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.0527 16.511C19.9703 17.444 21.0756 18.1222 21.8943 17.3691C22.3346 16.912 22.2578 16.2787 21.9637 15.9134C21.3529 15.1565 20.137 15.5368 20.0527 16.511Z",
			fill: "url(#paint44_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.1523 21.9471C20.0774 22.6871 20.9804 23.2229 21.6811 22.6347C22.0202 22.3218 22.0764 21.8066 21.8066 21.4637C21.3139 20.8342 20.2329 21.1509 20.1523 21.9471Z",
			fill: "url(#paint45_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.7091 11.7408C22.1325 11.2537 21.904 10.7498 21.7016 10.5287C21.149 9.92731 20.1523 10.2308 20.0848 11.0196C20.0193 11.7858 21.0291 12.3685 21.7091 11.7408Z",
			fill: "url(#paint46_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.6223 29.1883C15.4705 29.209 15.5605 29.3757 15.8246 29.5668C16.07 29.7448 16.3979 29.8909 16.5928 29.9452C16.8644 30.0202 16.8007 29.9096 16.7764 29.8684C16.5665 29.578 15.8883 29.1509 15.6223 29.1883Z",
			fill: "url(#paint47_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5061 3.54401C15.9482 3.28547 16.1992 2.97072 16.2086 2.87517C16.2274 2.70469 15.7065 2.91077 15.3412 3.17868C15.1632 3.30982 15.0339 3.44659 14.9965 3.54213C14.9421 3.68639 15.0883 3.76695 15.5061 3.54401Z",
			fill: "url(#paint48_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.118 19.3339C23.1161 19.3545 23.1124 19.3826 23.1124 19.4051C23.0899 19.999 23.7475 20.383 24.2739 19.9109C24.5437 19.643 24.5906 19.2215 24.3845 18.9292C24.021 18.414 23.2023 18.6744 23.118 19.3339Z",
			fill: "url(#paint49_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.1067 13.683C23.1067 13.7036 23.1067 13.7336 23.1067 13.7542C23.1348 14.3743 23.8561 14.7808 24.3451 14.2787C24.598 13.9902 24.5736 13.52 24.2907 13.2315C23.8542 12.7893 23.1348 13.0628 23.1067 13.683Z",
			fill: "url(#paint50_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.3586 2.35437C16.5666 2.27943 17.1118 2.05086 17.1661 2.00777C17.1661 2.0059 17.1661 2.00215 17.1661 2.00028C17.1193 1.99466 16.8195 2.07522 16.5535 2.17451C16.2799 2.27568 16.072 2.38434 16.0814 2.41994C16.1113 2.4368 16.2144 2.40495 16.3586 2.35437Z",
			fill: "url(#paint51_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.0972 4.98979C19.3539 4.73874 19.2433 4.50456 19.204 4.43711C18.9904 4.08303 18.4602 4.25913 18.3478 4.62821C18.3403 4.65256 18.3328 4.68629 18.3309 4.71064C18.2972 5.06286 18.7337 5.28205 19.0972 4.98979Z",
			fill: "url(#paint52_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2886 27.9032C18.972 27.6784 18.5692 27.8545 18.616 28.1973C18.6591 28.5121 19.105 28.8025 19.3973 28.5196C19.579 28.2966 19.4778 28.0362 19.2886 27.9032Z",
			fill: "url(#paint53_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.87 3.43938C18.1135 3.25578 18.1042 3.0778 18.1004 3.04408C18.0686 2.8024 17.6789 2.92605 17.4915 3.18272C17.4391 3.25391 17.4241 3.31011 17.4185 3.3326C17.3735 3.52931 17.5927 3.62111 17.87 3.43938Z",
			fill: "url(#paint54_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.3449 26.44C20.2981 26.8109 20.7459 27.1575 21.1749 26.8165C21.4465 26.5599 21.3622 26.2845 21.2798 26.1739C21.0213 25.8311 20.4011 26.0072 20.3449 26.44Z",
			fill: "url(#paint55_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.1583 6.85462C21.4056 6.55861 21.1976 6.27572 21.1527 6.22139C20.8379 5.83732 20.2384 5.98158 20.2103 6.44995C20.1841 6.88085 20.7836 7.21246 21.1583 6.85462Z",
			fill: "url(#paint56_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.0654 29.3062C17.8668 29.2724 17.7863 29.4017 17.9005 29.5722C18.0429 29.7839 18.4289 29.9787 18.5076 29.7876C18.5581 29.6359 18.3296 29.3511 18.0654 29.3062Z",
			fill: "url(#paint57_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.8387 24.3455C22.835 24.3586 22.8312 24.3755 22.8294 24.3886C22.7732 24.7502 23.1479 24.9825 23.5132 24.7015C23.7698 24.4654 23.723 24.2087 23.6612 24.1057C23.4907 23.8134 22.9436 23.9165 22.8387 24.3455Z",
			fill: "url(#paint58_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.6445 8.97126C23.785 8.79328 23.7288 8.4954 23.519 8.32117C23.2005 8.05513 22.7809 8.22374 22.8052 8.60781C22.8314 9.00124 23.3541 9.2935 23.6445 8.97126Z",
			fill: "url(#paint59_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.7167 2.30781C17.8947 2.2235 18.0333 2.10922 18.0464 2.06988C18.0689 2.00805 17.8403 2.08299 17.6755 2.18041C17.5837 2.23287 17.5218 2.28533 17.5087 2.32092C17.4937 2.35839 17.5481 2.38087 17.7167 2.30781Z",
			fill: "url(#paint60_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26.698 16.3006C26.4975 16.0401 26.1247 16.1881 26.091 16.5404C26.0891 16.5647 26.0891 16.5966 26.0891 16.619C26.1116 16.9656 26.4713 17.1211 26.683 16.8776C26.8516 16.6584 26.7842 16.413 26.698 16.3006Z",
			fill: "url(#paint61_linear_719_55524)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_719_55524",
				x1: 26.3248,
				y1: 16.6381,
				x2: 6.07569,
				y2: 16.6381,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_719_55524",
				x1: 26.3255,
				y1: 13.8599,
				x2: 6.07641,
				y2: 13.8599,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_719_55524",
				x1: 26.3248,
				y1: 19.412,
				x2: 6.07572,
				y2: 19.412,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_719_55524",
				x1: 26.3252,
				y1: 13.8197,
				x2: 6.07612,
				y2: 13.8197,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_719_55524",
				x1: 26.3248,
				y1: 19.4302,
				x2: 6.07569,
				y2: 19.4302,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_719_55524",
				x1: 26.3252,
				y1: 16.6315,
				x2: 6.07615,
				y2: 16.6315,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_719_55524",
				x1: 26.325,
				y1: 11.1702,
				x2: 6.07588,
				y2: 11.1702,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_719_55524",
				x1: 26.3248,
				y1: 22.0433,
				x2: 6.07571,
				y2: 22.0433,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint8_linear_719_55524",
				x1: 26.3252,
				y1: 16.621,
				x2: 6.07608,
				y2: 16.621,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint9_linear_719_55524",
				x1: 26.3248,
				y1: 11.1886,
				x2: 6.07574,
				y2: 11.1886,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint10_linear_719_55524",
				x1: 26.3252,
				y1: 22.0283,
				x2: 6.07606,
				y2: 22.0283,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint11_linear_719_55524",
				x1: 26.3253,
				y1: 22.0321,
				x2: 6.07621,
				y2: 22.0321,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint12_linear_719_55524",
				x1: 26.3252,
				y1: 11.1464,
				x2: 6.07608,
				y2: 11.1464,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint13_linear_719_55524",
				x1: 26.325,
				y1: 13.8297,
				x2: 6.07586,
				y2: 13.8297,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint14_linear_719_55524",
				x1: 26.3249,
				y1: 8.72962,
				x2: 6.0758,
				y2: 8.72962,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint15_linear_719_55524",
				x1: 26.325,
				y1: 19.4169,
				x2: 6.07595,
				y2: 19.4169,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint16_linear_719_55524",
				x1: 26.3252,
				y1: 24.4144,
				x2: 6.0761,
				y2: 24.4144,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint17_linear_719_55524",
				x1: 26.3252,
				y1: 24.4084,
				x2: 6.07606,
				y2: 24.4084,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint18_linear_719_55524",
				x1: 26.3254,
				y1: 8.72546,
				x2: 6.07631,
				y2: 8.72546,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint19_linear_719_55524",
				x1: 26.325,
				y1: 16.6215,
				x2: 6.0759,
				y2: 16.6215,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint20_linear_719_55524",
				x1: 26.3251,
				y1: 26.4921,
				x2: 6.07601,
				y2: 26.4921,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint21_linear_719_55524",
				x1: 26.3254,
				y1: 6.56253,
				x2: 6.0763,
				y2: 6.56253,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint22_linear_719_55524",
				x1: 26.3248,
				y1: 8.72916,
				x2: 6.07567,
				y2: 8.72916,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint23_linear_719_55524",
				x1: 26.3252,
				y1: 24.3912,
				x2: 6.0761,
				y2: 24.3912,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint24_linear_719_55524",
				x1: 26.3253,
				y1: 6.55628,
				x2: 6.07619,
				y2: 6.55628,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint25_linear_719_55524",
				x1: 26.3252,
				y1: 26.496,
				x2: 6.07607,
				y2: 26.496,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint26_linear_719_55524",
				x1: 26.3249,
				y1: 22.0209,
				x2: 6.07585,
				y2: 22.0209,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint27_linear_719_55524",
				x1: 26.3248,
				y1: 11.1566,
				x2: 6.07568,
				y2: 11.1566,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint28_linear_719_55524",
				x1: 26.3251,
				y1: 6.54442,
				x2: 6.07606,
				y2: 6.54442,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint29_linear_719_55524",
				x1: 26.3248,
				y1: 26.4828,
				x2: 6.07571,
				y2: 26.4828,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint30_linear_719_55524",
				x1: 26.3249,
				y1: 19.4033,
				x2: 6.07579,
				y2: 19.4033,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint31_linear_719_55524",
				x1: 26.3251,
				y1: 13.8004,
				x2: 6.07602,
				y2: 13.8004,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint32_linear_719_55524",
				x1: 26.325,
				y1: 28.2309,
				x2: 6.07587,
				y2: 28.2309,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint33_linear_719_55524",
				x1: 26.3252,
				y1: 28.2241,
				x2: 6.07609,
				y2: 28.2241,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint34_linear_719_55524",
				x1: 26.325,
				y1: 4.7216,
				x2: 6.07595,
				y2: 4.7216,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint35_linear_719_55524",
				x1: 26.3253,
				y1: 4.71644,
				x2: 6.07618,
				y2: 4.71644,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint36_linear_719_55524",
				x1: 26.325,
				y1: 6.54621,
				x2: 6.07597,
				y2: 6.54621,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint37_linear_719_55524",
				x1: 26.3251,
				y1: 26.4762,
				x2: 6.07599,
				y2: 26.4762,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint38_linear_719_55524",
				x1: 26.3249,
				y1: 24.3889,
				x2: 6.07582,
				y2: 24.3889,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint39_linear_719_55524",
				x1: 26.3251,
				y1: 8.69944,
				x2: 6.076,
				y2: 8.69944,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint40_linear_719_55524",
				x1: 26.325,
				y1: 28.2332,
				x2: 6.07592,
				y2: 28.2332,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint41_linear_719_55524",
				x1: 26.3251,
				y1: 4.70162,
				x2: 6.076,
				y2: 4.70162,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint42_linear_719_55524",
				x1: 26.3252,
				y1: 3.2548,
				x2: 6.07613,
				y2: 3.2548,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint43_linear_719_55524",
				x1: 26.325,
				y1: 29.5737,
				x2: 6.07592,
				y2: 29.5737,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint44_linear_719_55524",
				x1: 26.3249,
				y1: 16.6031,
				x2: 6.07577,
				y2: 16.6031,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint45_linear_719_55524",
				x1: 26.3252,
				y1: 22.0067,
				x2: 6.07612,
				y2: 22.0067,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint46_linear_719_55524",
				x1: 26.3252,
				y1: 11.1097,
				x2: 6.07606,
				y2: 11.1097,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint47_linear_719_55524",
				x1: 26.3253,
				y1: 29.5787,
				x2: 6.07617,
				y2: 29.5787,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint48_linear_719_55524",
				x1: 26.3252,
				y1: 3.24749,
				x2: 6.0761,
				y2: 3.24749,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint49_linear_719_55524",
				x1: 26.3251,
				y1: 19.3888,
				x2: 6.07605,
				y2: 19.3888,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint50_linear_719_55524",
				x1: 26.3251,
				y1: 13.7594,
				x2: 6.07599,
				y2: 13.7594,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint51_linear_719_55524",
				x1: 26.3253,
				y1: 2.21215,
				x2: 6.07624,
				y2: 2.21215,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint52_linear_719_55524",
				x1: 26.3248,
				y1: 4.68561,
				x2: 6.07577,
				y2: 4.68561,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint53_linear_719_55524",
				x1: 26.3252,
				y1: 28.2185,
				x2: 6.07609,
				y2: 28.2185,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint54_linear_719_55524",
				x1: 26.3248,
				y1: 3.22592,
				x2: 6.07568,
				y2: 3.22592,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint55_linear_719_55524",
				x1: 26.3248,
				y1: 26.4739,
				x2: 6.07576,
				y2: 26.4739,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint56_linear_719_55524",
				x1: 26.3251,
				y1: 6.50417,
				x2: 6.07602,
				y2: 6.50417,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint57_linear_719_55524",
				x1: 26.3254,
				y1: 29.5839,
				x2: 6.07627,
				y2: 29.5839,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint58_linear_719_55524",
				x1: 26.325,
				y1: 24.3821,
				x2: 6.07592,
				y2: 24.3821,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint59_linear_719_55524",
				x1: 26.3252,
				y1: 8.65002,
				x2: 6.07614,
				y2: 8.65002,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint60_linear_719_55524",
				x1: 26.3251,
				y1: 2.20143,
				x2: 6.07602,
				y2: 2.20143,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint61_linear_719_55524",
				x1: 26.3249,
				y1: 16.5819,
				x2: 6.07582,
				y2: 16.5819,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .1242,
						stopColor: "#01426A"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .6472,
						stopColor: "#3455DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .7296,
						stopColor: "#2C60DB"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .8738,
						stopColor: "#177DDD"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#009CDE"
					})
				]
			})
		] })
	]
});
export default SvgSphereXgLogo;
